export default __webpack_public_path__ + "static/media/32.b5db1583.png";